import React from 'react';
import Page from "../../components/Page";
import {useState} from "react";
import useInputs from "../../hooks/useInputs";
import GenericInputLayout from "../../layouts/GenericInput/GenericInputLayout";
import {
  CreateMaterial,
  DeleteMaterial,
  GetMaterials,
  UpdateMaterial
} from "../../api/MaterialApi";
import ItemUtils from "../../utils/ItemUtils";
import {useSnackbar} from "notistack";
import {MaterialInputs} from "./MaterialInputs";


export default function MaterialPage() {
  const [items, setItems] = useState([]);
  const inputs = useInputs(MaterialInputs);
  const {enqueueSnackbar} = useSnackbar();

  const populate = () => {
    GetMaterials().then(json => {
      setItems(json);
    })
  }

  React.useEffect(() => {
    populate()
  }, []);

  const handleDelete = async (e, item) => {

    return DeleteMaterial(item.id).then(() => {
      setItems(ItemUtils.removeItem(items, item));
      enqueueSnackbar(`Successfully deleted textbook: ${item.name}`, {variant: 'success'});
    });
  }

  const handleEdit = async (values) => {

    return UpdateMaterial(values.id, values).then(json => {
      setItems(ItemUtils.replaceItem(items, json));
    });
  }

  return (
      <Page title="Materials" sx={{ position: 'relative'}}>
        <GenericInputLayout
            header="Materials"
            newHeader="Add Material"
            inputs={inputs}
            items={items}
            filterBy={'name'}
            createAction={CreateMaterial}
            onCreate={populate}
            onEdit={handleEdit}
            onDelete={handleDelete}
            getDisplayName={item => item.name}
        />
      </Page>
  )
}